import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/home.vue"
import Index from "@/views/index.vue"

import DownLoad from "@/views/download.vue"
import Introduction from "@/views/introduction.vue"
import About from "@/views/about.vue"
Vue.use(Router)


export default new Router({
  mode: 'hash',  // 路由模式：hash | history | abstract

  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home, // 路由懒加载
      children: [
        {
          path: '/',
          name: 'index',
          component: Index
        },
        {
          path: '/download',
          name: 'download',
          component: DownLoad
        },
        {
          path: '/introduction',
          name: 'introduction',
          component: Introduction
        },
        {
          path: '/about',
          name: 'about',
          component: About
        },
      ]
    },

    {
      path: '*',
      redirect: '/'  // 404 重定向
    }
  ]
})
